// App.js
import { useEffect } from "react";
import "../App.css";

const PublicMainPage = () => {
  useEffect(() => {
    // Stars efektini oluştur
    createStars();
  }, []);

  // Yıldız efektini oluşturma fonksiyonu
  const createStars = () => {
    const starsContainer = document.querySelector(".stars");
    if (starsContainer) {
      for (let i = 0; i < 50; i++) {
        const star = document.createElement("div");
        star.className = "star";
        star.style.left = `${Math.random() * 100}%`;
        star.style.animationDuration = `${Math.random() * 3 + 2}s`;
        star.style.animationDelay = `${Math.random() * 3}s`;
        starsContainer.appendChild(star);
      }
    }
  };

  return (
    <div className="app">
      <div className="stars"></div>

      <div className="container">
        <img src="/logo.png" alt="Futurify AI Logo" className="logo" />
        <h1 className="title">Futurify AI</h1>
        <p className="subtitle">Tarot, Palm & Coffee Reading AI Powered</p>

        <div className="store-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=com.weltlab.futurify"
            className="store-button"
          >
            <img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBkPSJNMyA2LjVsMTItN2wxMiA3TTMgNi41bDEyIDdsMTItN00zIDYuNXYxMWwxMiA3bDEyLTd2LTExIi8+PC9zdmc+"
              alt="Play Store Icon"
            />
            Google Play
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicMainPage;
